import { FC } from 'react';

// Quarks
import Flex from 'quarks/Flex';

import StandardCard from 'components/Cards/StandardCard';

import type { ContentfulComponentCardDeck } from 'graphqlTypes';

interface ComponentCardDeckProps extends FlexProps, ContentfulComponentCardDeck {
  backgroundIsDark?: boolean;
  pageType?: string;
}

const StandardCardDeck: FC<ComponentCardDeckProps> = ({ card, backgroundIsDark, pageType, ...props }) => {
  const length = card?.length || 0;

  return (
    <Flex
      gap="48px"
      overflowX="hidden"
      overflowY="hidden"
      sm={{ alignItems: 'center', flexDirection: 'column' }}
      {...props}
    >
      <Flex flexDirection="column" gap="16px" width="100%">
        {card && (
          <Flex
            gap="30px"
            justifyContent="flex-start"
            marginBottom={length > 3 ? 0 : 48}
            className="card"
            xs={{ flexDirection: 'column' }}
            md={{ flexDirection: 'row', minWidth: `calc(100% * ${length} + (30px * ${length - 1}))` }}
          >
            {card.map(cardData => (
              <Flex key={cardData?.id} width="100%" maxWidth="100%" md={{ maxWidth: '370px' }}>
                <StandardCard pageType={pageType} backgroundIsDark={backgroundIsDark} {...cardData} />
              </Flex>
            ))}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default StandardCardDeck;
